import Link from 'next/link'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

function LockMetNavigation() {
  const { t } = useTranslation()
  const { asPath, query } = useRouter()

  const tabs = [
    {
      href: `/${query.shortName}/lock-met`,
      title: t('lock-navigation.create-lock')
    },
    {
      href: `/${query.shortName}/lock-met/positions`,
      title: t('lock-navigation.locked-positions')
    }
  ]

  return (
    <ul className="bg-blue-secondary mb-8 inline-block space-x-1 rounded-lg p-1 font-semibold text-white">
      {tabs.map(({ href, title }) => (
        <li className="inline" key={href}>
          <Link
            className={`inline-block rounded-lg px-5 py-2 ${
              asPath === href ? 'bg-gray-tertiary' : ''
            } hover:bg-gray-tertiary/50`}
            href={href}
          >
            {title}
          </Link>
        </li>
      ))}
    </ul>
  )
}

export default LockMetNavigation
